import { render, staticRenderFns } from "./ActivityDetail.vue?vue&type=template&id=30a4e96b&scoped=true&"
import script from "./ActivityDetail.vue?vue&type=script&lang=js&"
export * from "./ActivityDetail.vue?vue&type=script&lang=js&"
import style0 from "./ActivityDetail.vue?vue&type=style&index=0&id=30a4e96b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30a4e96b",
  null
  
)

export default component.exports